module.exports = __webpack_public_path__ + "static/media/visa-card-web-icon.2f076965.svg";